document.documentElement.classList.remove('no-js');

function initMenu(root = document) {
  const menuButton = root.querySelector?.('.menu-button');
  const nav = root.querySelector?.('#MobileNav');
  if (!menuButton || menuButton.dataset.initialized) return;
  menuButton.dataset.initialized = 'true';
  menuButton.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    nav?.classList.toggle('open', !open);
  });
}

function initProductSection(section) {
  if (section.dataset.initialized) return;
  section.dataset.initialized = 'true';

  const variantsNode = section.querySelector('[data-product-json]');
  const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
  const idInput = section.querySelector('[data-variant-id]');
  const price = section.querySelector('[data-price]');
  const compare = section.querySelector('[data-compare-price]');
  const addButton = section.querySelector('[data-add-button]');
  const addText = section.querySelector('[data-add-text]');
  const quantityInput = section.querySelector('[data-quantity]');
  const currency = window.Shopify?.currency?.active || 'USD';
  const formatMoney = (cents) => new Intl.NumberFormat(
    document.documentElement.lang || 'en',
    { style: 'currency', currency }
  ).format(cents / 100);

  const updateVariant = () => {
    const selected = Array.from(section.querySelectorAll('[data-option-index]'))
      .map((fieldset) => fieldset.querySelector('input:checked')?.value);
    const variant = variants.find((item) =>
      item.options.every((value, index) => value === selected[index])
    );

    if (!variant) {
      addButton.disabled = true;
      addText.textContent = 'UNAVAILABLE';
      return;
    }

    idInput.value = variant.id;
    price.textContent = formatMoney(variant.price);
    if (variant.compare_at_price > variant.price) {
      compare.hidden = false;
      compare.textContent = formatMoney(variant.compare_at_price);
    } else {
      compare.hidden = true;
    }

    addButton.disabled = !variant.available;
    addText.textContent = variant.available ? addButton.dataset.readyLabel : 'SOLD OUT';
    section.querySelectorAll('.offer-card').forEach((card) => {
      const option = card.querySelector('input');
      const quantity = Number(option.value);
      const discount = Number(option.dataset.discount || 0);
      const regularTotal = variant.price * quantity;
      const offerTotal = Math.round(regularTotal * (100 - discount) / 100);
      card.querySelector('[data-offer-price]').textContent = formatMoney(offerTotal);
      const compareNode = card.querySelector('[data-offer-compare]');
      if (compareNode) compareNode.textContent = formatMoney(regularTotal);
    });

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  section.querySelectorAll('[data-option-index] input')
    .forEach((input) => input.addEventListener('change', updateVariant));

  section.querySelectorAll('.offer-card input').forEach((input) => {
    input.addEventListener('change', () => {
      quantityInput.value = input.value;
      section.querySelectorAll('.offer-card').forEach((card) => {
        card.classList.toggle('selected', card.contains(input) && input.checked);
      });
    });
  });

  section.querySelector('[data-buy-now]')?.addEventListener('click', async (event) => {
    event.preventDefault();
    const button = event.currentTarget;
    if (button.disabled) return;
    button.disabled = true;
    addText.textContent = 'LOADING…';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(idInput.value), quantity: Number(quantityInput.value) }]
        })
      });
      if (!response.ok) throw new Error('Unable to add item');
      window.location.href = '/checkout';
    } catch (error) {
      button.disabled = false;
      addText.textContent = 'TRY AGAIN';
    }
  });

  section.querySelectorAll('[data-media-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const mainImage = section.querySelector('[data-main-media] img');
      if (!mainImage || !button.dataset.mediaSrc) return;

      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = button.dataset.mediaSrc;
      mainImage.alt = button.dataset.mediaAlt || '';
      section.querySelectorAll('[data-media-button]')
        .forEach((thumb) => thumb.classList.toggle('active', thumb === button));

      const counter = section.querySelector('.image-number');
      if (counter) {
        counter.textContent = `${button.dataset.mediaIndex} / ${section.querySelectorAll('[data-media-button]').length}`;
      }
    });
  });
}

function initReviews(wrapper) {
  if (wrapper.dataset.initialized) return;
  wrapper.dataset.initialized = 'true';
  const slides = Array.from(wrapper.querySelectorAll('[data-review-slide]'));
  const counter = wrapper.querySelector('[data-review-counter]');
  let index = 0;
  const show = (next) => {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-hidden', slideIndex !== index);
    });
    if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
  };
  wrapper.querySelector('[data-review-prev]')?.addEventListener('click', () => show(index - 1));
  wrapper.querySelector('[data-review-next]')?.addEventListener('click', () => show(index + 1));
}

function initTheme(root = document) {
  initMenu(root);
  if (root.matches?.('[data-product-section]')) initProductSection(root);
  if (root.matches?.('[data-reviews]')) initReviews(root);
  root.querySelectorAll?.('[data-product-section]').forEach(initProductSection);
  root.querySelectorAll?.('[data-reviews]').forEach(initReviews);
}

document.addEventListener('DOMContentLoaded', () => initTheme(document));
document.addEventListener('shopify:section:load', (event) => initTheme(event.target));
